import { IconChevronRight, IconChevronLeft } from '@tabler/icons-react'

type TodayNavProps = {
  onPrev: () => void
  onToday: () => void
  onNext: () => void
  activeView: string | null
  title?: string
}

const NAV_BUTTON =
  'inline-flex h-[32px] w-[32px] shrink-0 cursor-pointer items-center justify-center rounded-md border border-[#D8DBE0] bg-white transition hover:bg-[#F4F6F8]'

const TodayNav: React.FC<TodayNavProps> = ({ onPrev, onToday, onNext, title }) => {
  return (
    <div className="flex items-center gap-3">
      <div className="flex items-center gap-1">
        <button type="button" onClick={onPrev} aria-label="Previous period" className={NAV_BUTTON}>
          <IconChevronLeft size={17} stroke={2} className="text-[#4A5160]" />
        </button>
        {title && (
          <span className="min-w-[148px] text-center text-[17px] leading-none font-bold">
            {title}
          </span>
        )}
        <button type="button" onClick={onNext} aria-label="Next period" className={NAV_BUTTON}>
          <IconChevronRight size={17} stroke={2} className="text-[#4A5160]" />
        </button>
      </div>
      <button
        type="button"
        onClick={onToday}
        className="schedule-v2-mulish inline-flex shrink-0 cursor-pointer items-center gap-1.5 rounded-md border border-[#D8DBE0] bg-white px-2.5 py-[3px] !text-[16px] !font-semibold text-[#33383F] transition hover:bg-[#F4F6F8]"
      >
        Today
      </button>
    </div>
  )
}
export default TodayNav
